import React, { useEffect, useRef } from "react";
import "./JourneySection.css";

const steps = [
  {
    num: 1,
    title: "Discovery Call",
    desc: "We'll understand your financial goals, risk tolerance, and current situation in a comprehensive consultation.",
  },
  {
    num: 2,
    title: "Custom Strategy",
    desc: "Our team creates a personalized wealth-building strategy tailored specifically to your needs and objectives.",
  },
  {
    num: 3,
    title: "Implementation",
    desc: "We execute your strategy with precision, managing every detail to ensure optimal results.",
  },
  {
    num: 4,
    title: "Ongoing Optimization",
    desc: "Continuous monitoring and adjustments keep your portfolio performing at peak efficiency.",
  },
];

const JourneySection = () => {
  const sectionRef = useRef(null);
  const timelineRef = useRef(null);
  const stepsRef = useRef([]);
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const playedRef = useRef(false);

  useEffect(() => {
    const revealObs = new IntersectionObserver(
      (entries) =>
        entries.forEach(
          (e) => e.isIntersecting && e.target.classList.add("show"),
        ),
      { threshold: 0.1 },
    );
    if (titleRef.current) revealObs.observe(titleRef.current);
    if (subtitleRef.current) revealObs.observe(subtitleRef.current);

    const journeyObs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            timelineRef.current?.classList.remove("wc-ui-timeline-animate");
            stepsRef.current.forEach((s) =>
              s?.classList.remove("wc-ui-step-show"),
            );
            playedRef.current = false;

            if (!playedRef.current) {
              playedRef.current = true;
              timelineRef.current?.classList.add("wc-ui-timeline-animate");
              stepsRef.current.forEach((step, i) => {
                setTimeout(
                  () => step?.classList.add("wc-ui-step-show"),
                  600 + i * 300,
                );
              });
            }
          }
        });
      },
      { threshold: 0.3 },
    );
    if (sectionRef.current) journeyObs.observe(sectionRef.current);

    return () => {
      revealObs.disconnect();
      journeyObs.disconnect();
    };
  }, []);

  return (
    <section className="wc-ui-journey-section" ref={sectionRef}>
      <div className="wc-ui-journey-container">
        <h2 className="wc-ui-journey-title wc-ui-reveal" ref={titleRef}>
          Your Journey to <br />{" "}
          <span className="wc-ui-gradient-text">Financial Freedom</span>
        </h2>
        <p className="wc-ui-journey-subtitle wc-ui-reveal" ref={subtitleRef}>
          Our streamlined onboarding process gets you started in 4 simple steps.
        </p>
        <div className="wc-ui-journey-wrapper">
          <div className="wc-ui-journey-timeline" ref={timelineRef}>
            <div className="wc-ui-journey-line"></div>
          </div>
          <div className="wc-ui-journey-steps">
            {steps.map((step, i) => (
              <div
                key={i}
                className="wc-ui-journey-step"
                ref={(el) => (stepsRef.current[i] = el)}
              >
                <div className="wc-ui-journey-dot">
                  <span className="wc-ui-journey-dot-number">{step.num}</span>
                </div>
                <h3 className="wc-ui-journey-step-title">{step.title}</h3>
                <p className="wc-ui-journey-step-desc">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default JourneySection;
